import type { ComparisonConfig } from './ComparisonPage';

const HOTELOGIX_ES: ComparisonConfig = {
  slug: 'hotelstack-vs-hotelogix',
  competitorName: 'Hotelogix',
  heroTitle: 'HotelStack.io vs Hotelogix',
  heroSubtitle: 'Una comparativa completa de dos plataformas líderes de gestión hotelera. Descubre cómo HotelStack.io ofrece más funciones, arquitectura moderna y mejor relación calidad-precio que Hotelogix.',
  overviewComparison: [
    { label: 'Módulos Totales', hotelstack: '36 Módulos Integrados', competitor: '15 Módulos' },
    { label: 'Arquitectura', hotelstack: 'SaaS Nativo en la Nube', competitor: 'Nube Heredada' },
    { label: 'Alcance Global', hotelstack: 'Más de 40 Países', competitor: 'Principalmente Asia' },
    { label: 'Channel Manager', hotelstack: 'Integrado (100+ OTAs)', competitor: 'Complemento de Pago' },
    { label: 'Motor de Reservas', hotelstack: 'BookMyRoom.io (Gratis)', competitor: 'Widget Básico' },
    { label: 'Soporte', hotelstack: 'Dedicado 24/7', competitor: 'Correo + Chat' },
  ],
  featureTable: [
    {
      category: 'PMS Principal',
      features: [
        { name: 'Tablero Visual de Habitaciones', hotelstack: true, competitor: true },
        { name: 'Check-In con Arrastrar y Soltar', hotelstack: true, competitor: false },
        { name: 'Asistente de Auditoría Nocturna', hotelstack: true, competitor: true },
        { name: 'Gestión de Folio del Huésped', hotelstack: true, competitor: true },
        { name: 'Portal de Check-In en Línea', hotelstack: true, competitor: false },
        { name: 'Modal de Reserva sin Cita', hotelstack: true, competitor: 'Limitado' },
      ],
    },
    {
      category: 'Gestión de Ingresos',
      features: [
        { name: 'Reglas de Precios Dinámicos', hotelstack: true, competitor: false },
        { name: 'Simulador de Ingresos Hipotético', hotelstack: true, competitor: false },
        { name: 'Monitor de Tarifas de la Competencia', hotelstack: true, competitor: false },
        { name: 'Previsión de Demanda', hotelstack: true, competitor: false },
        { name: 'Analíticas RevPAR', hotelstack: true, competitor: 'Básico' },
      ],
    },
    {
      category: 'Gestión de Huéspedes',
      features: [
        { name: 'Perfiles de Huésped 360 Grados', hotelstack: true, competitor: 'Básico' },
        { name: 'Gestión de Programa de Fidelización', hotelstack: true, competitor: false },
        { name: 'Automatización de Comunicación con Huéspedes', hotelstack: true, competitor: 'Limitado' },
        { name: 'Analíticas de Gasto del Huésped', hotelstack: true, competitor: false },
        { name: 'Carga de ID y Captura de Foto', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'A&B y POS',
      features: [
        { name: 'Terminal POS', hotelstack: true, competitor: false },
        { name: 'Plano de Mesas del Restaurante', hotelstack: true, competitor: false },
        { name: 'Sistema de Pantalla de Cocina', hotelstack: true, competitor: false },
        { name: 'Módulo de Servicio a Habitación', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Informes y Analíticas',
      features: [
        { name: 'Informe Rápido', hotelstack: true, competitor: true },
        { name: 'Estado de Pérdidas y Ganancias', hotelstack: true, competitor: false },
        { name: 'Informe de Ritmo', hotelstack: true, competitor: false },
        { name: 'Informes de Cumplimiento Fiscal', hotelstack: true, competitor: 'Básico' },
        { name: 'Constructor de Informes Personalizados', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Multi-Propiedad',
      features: [
        { name: 'Panel de Cadena', hotelstack: true, competitor: true },
        { name: 'Analíticas entre Propiedades', hotelstack: true, competitor: false },
        { name: 'Gestión Centralizada de Tarifas', hotelstack: true, competitor: false },
        { name: 'Configuración de Marca', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Resiliencia y Sin Conexión',
      features: [
        { name: 'PWA con Capacidad Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Cola de Cambios Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Sincronización en Segundo Plano al Reconectar', hotelstack: true, competitor: false },
        { name: 'Reconciliación con Detección de Conflictos', hotelstack: true, competitor: false },
        { name: 'Recepción Instalable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventas Corporativas y de Grupos',
      features: [
        { name: 'Gestión de Tarifas Corporativas', hotelstack: true, competitor: false },
        { name: 'Reserva de Grupo con Listas de Habitaciones', hotelstack: true, competitor: 'Complemento' },
        { name: 'Informes de Antigüedad de Saldos y Producción', hotelstack: true, competitor: false },
        { name: 'Reservas de Restaurante', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personal y RR. HH.',
      features: [
        { name: 'Directorio de Personal y Turnos', hotelstack: true, competitor: false },
        { name: 'Procesamiento de Nómina', hotelstack: true, competitor: false },
        { name: 'Permisos y Asistencia', hotelstack: true, competitor: false },
        { name: 'Analíticas de Desempeño', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$60+',
    hotelstackNote: 'Los 36 módulos incluidos. Sin restricciones de funciones. Incorporación y migración de datos gratuitas. Precios regionales en EUR, GBP, AED, INR, THB.',
    competitorNote: 'Plan básico con módulos limitados. El channel manager y las funciones avanzadas tienen coste adicional.',
  },
  advantages: [
    'Más del doble de módulos (36 vs 15) sin cargos adicionales por funciones esenciales',
    'Arquitectura moderna nativa en la nube construida en 2024 con sincronización en tiempo real en todos los dispositivos',
    'Soporte multidivisa con precios regionales en 6 monedas y herramientas de cumplimiento para más de 40 países',
    'Motor de reservas integrado vía BookMyRoom.io — reservas directas sin comisión incluidas',
    'Gestión avanzada de ingresos con precios dinámicos, previsión de demanda y simuladores hipotéticos',
    'Módulo completo de A&B y POS con gestión de mesas, pantalla de cocina y servicio a habitación',
    'Precio inicial más bajo con más funciones incluidas en el plan base',
    'Migración de datos gratuita desde Hotelogix con soporte de incorporación dedicado',
  ],
  verdict: {
    title: 'Nuestro Veredicto',
    summary: 'HotelStack.io es la opción más sólida para hoteles que buscan una plataforma moderna e integral. Con 36 módulos, gestión de ingresos integrada, capacidades de A&B y precios más bajos, ofrece un valor significativamente superior a Hotelogix. Hotelogix puede ser adecuado para hoteles económicos que solo necesitan funcionalidades básicas de PMS.',
    bestFor: [
      'Hoteles que desean una plataforma moderna integral sin cargos adicionales',
      'Propiedades que necesitan gestión avanzada de ingresos y precios dinámicos',
      'Hoteles que requieren capacidades de A&B, POS y servicio a habitación',
      'Propiedades que necesitan cumplimiento regional y facturación multidivisa',
      'Cadenas multi-propiedad que necesitan analíticas centralizadas y gestión de tarifas',
    ],
  },
  faqItems: [
    { question: '¿Puedo migrar de Hotelogix a HotelStack.io?', answer: 'Sí. Nuestro equipo gestiona la migración completa de datos desde Hotelogix, incluyendo perfiles de huéspedes, historial de reservas, planes tarifarios y configuraciones de habitaciones. La migración es gratuita y normalmente se completa en 48 horas sin tiempo de inactividad.' },
    { question: '¿HotelStack.io tiene todas las funciones que ofrece Hotelogix?', answer: 'HotelStack.io incluye todas las funciones de Hotelogix más 17 módulos adicionales como gestión de ingresos, A&B/POS, programas de fidelización, herramientas de cumplimiento y analíticas avanzadas que Hotelogix no ofrece.' },
    { question: '¿Cómo se comparan los precios entre HotelStack.io y Hotelogix?', answer: 'HotelStack.io comienza en $49/mes con los 36 módulos incluidos. Precios regionales disponibles en EUR, GBP, AED, INR y THB. Hotelogix comienza en aproximadamente $60+/mes para su plan básico, con cargos adicionales por channel manager y otras funciones.' },
    { question: '¿Es HotelStack.io adecuado para hoteles pequeños que actualmente usan Hotelogix?', answer: 'Por supuesto. Nuestro plan Starter está diseñado para propiedades de hasta 50 habitaciones con todas las funciones desbloqueadas. Muchos hoteles pequeños cambian de Hotelogix por los módulos adicionales y el precio más bajo.' },
  ],
};

const CLOUDBEDS_ES: ComparisonConfig = {
  slug: 'hotelstack-vs-cloudbeds',
  competitorName: 'Cloudbeds',
  heroTitle: 'HotelStack.io vs Cloudbeds',
  heroSubtitle: 'Ambas son plataformas nativas en la nube. HotelStack.io ofrece más módulos, precios más bajos y capacidades completas de A&B/POS que Cloudbeds no tiene — todo con precios regionales multidivisa.',
  overviewComparison: [
    { label: 'Módulos Totales', hotelstack: '36 Módulos', competitor: 'Más de 20 Módulos' },
    { label: 'Precios', hotelstack: 'Desde $49/mes', competitor: 'Desde $100+/mes' },
    { label: 'Precios Regionales', hotelstack: '6 Monedas', competitor: 'Solo USD' },
    { label: 'A&B / POS', hotelstack: 'Integrado', competitor: 'No Disponible' },
    { label: 'Motor de Reservas', hotelstack: 'BookMyRoom.io (Gratis)', competitor: 'Widget Básico' },
    { label: 'Incorporación', hotelstack: 'Gratis + Dedicada', competitor: 'Autoservicio' },
  ],
  featureTable: [
    {
      category: 'PMS Principal',
      features: [
        { name: 'Tablero Visual de Habitaciones', hotelstack: true, competitor: true },
        { name: 'Gestión de Reservas', hotelstack: true, competitor: true },
        { name: 'Reservas Grupales', hotelstack: true, competitor: true },
        { name: 'Asistente de Auditoría Nocturna', hotelstack: true, competitor: true },
        { name: 'Portal de Check-In en Línea', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'Cumplimiento Regional',
      features: [
        { name: 'Facturación Multidivisa', hotelstack: true, competitor: 'Limitado' },
        { name: 'Automatización Fiscal Regional', hotelstack: true, competitor: false },
        { name: 'Cumplimiento de Registro de Huéspedes', hotelstack: true, competitor: false },
        { name: 'Protección de Datos GDPR', hotelstack: true, competitor: true },
        { name: 'Pasarelas de Pago Regionales', hotelstack: true, competitor: 'Limitado' },
        { name: 'Facturación Localizada', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Gestión de Ingresos',
      features: [
        { name: 'Precios Dinámicos', hotelstack: true, competitor: true },
        { name: 'Analíticas de Ingresos', hotelstack: true, competitor: true },
        { name: 'Monitor de Tarifas de la Competencia', hotelstack: true, competitor: 'Complemento' },
        { name: 'Simulador Hipotético', hotelstack: true, competitor: false },
        { name: 'Previsión de Demanda', hotelstack: true, competitor: 'Básico' },
      ],
    },
    {
      category: 'A&B y Operaciones',
      features: [
        { name: 'Terminal POS', hotelstack: true, competitor: false },
        { name: 'Módulo de Servicio a Habitación', hotelstack: true, competitor: false },
        { name: 'Tablero de Limpieza', hotelstack: true, competitor: true },
        { name: 'Órdenes de Trabajo de Mantenimiento', hotelstack: true, competitor: false },
        { name: 'Programación de Personal', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Cumplimiento e Informes',
      features: [
        { name: 'Informes Fiscales Regionales', hotelstack: true, competitor: false },
        { name: 'Registro de Auditoría', hotelstack: true, competitor: true },
        { name: 'Estado de Pérdidas y Ganancias', hotelstack: true, competitor: 'Limitado' },
        { name: 'Constructor de Informes Personalizados', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'Resiliencia y Sin Conexión',
      features: [
        { name: 'PWA con Capacidad Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Cola de Cambios Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Sincronización en Segundo Plano al Reconectar', hotelstack: true, competitor: false },
        { name: 'Reconciliación con Detección de Conflictos', hotelstack: true, competitor: false },
        { name: 'Recepción Instalable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventas Corporativas y de Grupos',
      features: [
        { name: 'Gestión de Tarifas Corporativas', hotelstack: true, competitor: false },
        { name: 'Reserva de Grupo con Listas de Habitaciones', hotelstack: true, competitor: 'Limitado' },
        { name: 'Informes de Antigüedad de Saldos y Producción', hotelstack: true, competitor: false },
        { name: 'Reservas de Restaurante', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personal y RR. HH.',
      features: [
        { name: 'Directorio de Personal y Turnos', hotelstack: true, competitor: 'Complemento' },
        { name: 'Procesamiento de Nómina', hotelstack: true, competitor: false },
        { name: 'Permisos y Asistencia', hotelstack: true, competitor: false },
        { name: 'Analíticas de Desempeño', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$100+',
    hotelstackNote: 'Los 36 módulos incluidos. Precios regionales en EUR, GBP, AED, INR, THB. Incorporación y migración gratuitas.',
    competitorNote: 'Precios solo en USD ($100+/mes). Cargos adicionales por funciones premium e integraciones.',
  },
  advantages: [
    'Los 36 módulos incluidos a aproximadamente la mitad del coste — sin cargos adicionales por funciones esenciales',
    'Precios regionales en 6 monedas — sin sorpresas de tipo de cambio para propiedades internacionales',
    'Módulo completo de A&B con terminal POS, servicio a habitación y gestión de cocina',
    'Herramientas de cumplimiento regional para automatización fiscal, registro de huéspedes y GDPR',
    'Soporte multi-pasarela de pago vía PaymentHooks.com (Stripe, PayPal, más de 50 pasarelas) para métodos globales y locales',
    'Módulo de gestión de personal con nóminas, asistencia y programación de turnos',
    'Gestión de mantenimiento y órdenes de trabajo con seguimiento de activos',
    'Incorporación gratuita y migración de datos con equipo de soporte dedicado',
  ],
  verdict: {
    title: 'Nuestro Veredicto',
    summary: 'HotelStack.io ofrece más módulos, mejor valor y herramientas operativas completas a aproximadamente la mitad del precio de Cloudbeds. Mientras que Cloudbeds es una plataforma sólida para PMS básico y gestión de canales, HotelStack.io añade A&B/POS, gestión de personal, mantenimiento y herramientas avanzadas de ingresos — todo incluido en el precio base.',
    bestFor: [
      'Hoteles que desean una plataforma integral completa a un precio más bajo',
      'Propiedades que necesitan A&B, POS y gestión de personal en un solo sistema',
      'Hoteles que desean cumplimiento regional y facturación multidivisa',
      'Propiedades que prefieren incorporación dedicada en lugar de configuración autoservicio',
      'Cadenas multi-propiedad que necesitan analíticas centralizadas y gestión de tarifas',
    ],
  },
  faqItems: [
    { question: '¿Puedo migrar de Cloudbeds a HotelStack.io?', answer: 'Sí. Nuestro equipo de incorporación gestiona la migración completa de datos desde Cloudbeds, incluyendo perfiles de huéspedes, historial de reservas y planes tarifarios. La migración es gratuita y normalmente se completa en 48 horas.' },
    { question: '¿HotelStack.io soporta los mismos canales OTA que Cloudbeds?', answer: 'Sí. HotelStack.io se conecta a más de 100 OTAs incluyendo Booking.com, Expedia, Airbnb, Agoda y plataformas regionales. También se soporta conectividad GDS vía Amadeus y Sabre.' },
    { question: '¿Por qué HotelStack.io es más económico que Cloudbeds?', answer: 'HotelStack.io incluye los 36 módulos en cada plan sin cargos adicionales. Los precios regionales en 6 monedas reducen aún más los costes. Cloudbeds cobra extra por funciones premium y ofrece solo precios en USD.' },
    { question: '¿Funciona HotelStack.io para propiedades internacionales?', answer: 'Por supuesto. HotelStack.io soporta facturación multidivisa, cumplimiento fiscal regional y pasarelas de pago internacionales. Hoteles en más de 40 países usan HotelStack.io para gestionar sus operaciones.' },
  ],
};

const MEWS_ES: ComparisonConfig = {
  slug: 'hotelstack-vs-mews',
  competitorName: 'Mews',
  heroTitle: 'HotelStack.io vs Mews',
  heroSubtitle: 'Mews se dirige a hoteles empresariales con precios premium e implementación de pago. HotelStack.io ofrece la misma experiencia moderna con más módulos a una fracción del coste — incorporación gratuita incluida.',
  overviewComparison: [
    { label: 'Segmento Hotelero', hotelstack: 'PYME a Empresarial', competitor: 'Solo Empresarial' },
    { label: 'Precios', hotelstack: 'Desde $49/mes', competitor: '$200+/mes' },
    { label: 'Módulos Totales', hotelstack: '36 Integrados', competitor: 'Más de 15 Principales' },
    { label: 'A&B / POS', hotelstack: 'Integrado', competitor: 'Vía Integración' },
    { label: 'Calidad UI/UX', hotelstack: 'Moderno Oscuro de Lujo', competitor: 'Moderno Minimalista' },
    { label: 'Incorporación', hotelstack: 'Gratis + Dedicada', competitor: 'Implementación de Pago' },
  ],
  featureTable: [
    {
      category: 'PMS Principal',
      features: [
        { name: 'Arquitectura Nativa en la Nube', hotelstack: true, competitor: true },
        { name: 'UI/UX Moderno', hotelstack: true, competitor: true },
        { name: 'Sincronización en Tiempo Real', hotelstack: true, competitor: true },
        { name: 'Acceso Multi-Dispositivo', hotelstack: true, competitor: true },
        { name: 'Automatización de Auditoría Nocturna', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'Cumplimiento Regional',
      features: [
        { name: 'Facturación Multidivisa', hotelstack: true, competitor: true },
        { name: 'Automatización Fiscal Regional', hotelstack: true, competitor: 'Solo UE' },
        { name: 'Cumplimiento de Registro de Huéspedes', hotelstack: true, competitor: 'Solo UE' },
        { name: 'Protección de Datos GDPR', hotelstack: true, competitor: true },
        { name: 'Pasarelas de Pago Regionales', hotelstack: true, competitor: 'Limitado' },
        { name: 'Precios Regionales (6 Monedas)', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ingresos y Distribución',
      features: [
        { name: 'Channel Manager', hotelstack: true, competitor: true },
        { name: 'Precios Dinámicos', hotelstack: true, competitor: true },
        { name: 'Motor de Reservas', hotelstack: true, competitor: true },
        { name: 'Analíticas de Ingresos', hotelstack: true, competitor: true },
        { name: 'Simulador Hipotético', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Operaciones',
      features: [
        { name: 'Gestión de Limpieza', hotelstack: true, competitor: true },
        { name: 'Módulo POS / A&B', hotelstack: true, competitor: 'Vía Integración' },
        { name: 'Programación de Personal', hotelstack: true, competitor: false },
        { name: 'Mantenimiento / Órdenes de Trabajo', hotelstack: true, competitor: false },
        { name: 'Comunicación con Huéspedes', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'Precios y Soporte',
      features: [
        { name: 'Incorporación Gratuita', hotelstack: true, competitor: false },
        { name: 'Migración de Datos Gratuita', hotelstack: true, competitor: false },
        { name: 'Soporte 24/7', hotelstack: true, competitor: 'Horario Laboral' },
        { name: 'Sin Tarifa de Implementación', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Resiliencia y Sin Conexión',
      features: [
        { name: 'PWA con Capacidad Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Cola de Cambios Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Sincronización en Segundo Plano al Reconectar', hotelstack: true, competitor: false },
        { name: 'Reconciliación con Detección de Conflictos', hotelstack: true, competitor: false },
        { name: 'Recepción Instalable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventas Corporativas y de Grupos',
      features: [
        { name: 'Gestión de Tarifas Corporativas', hotelstack: true, competitor: 'Complemento' },
        { name: 'Reserva de Grupo con Listas de Habitaciones', hotelstack: true, competitor: true },
        { name: 'Informes de Antigüedad de Saldos y Producción', hotelstack: true, competitor: 'Complemento' },
        { name: 'Reservas de Restaurante', hotelstack: true, competitor: 'Vía Integración' },
      ],
    },
    {
      category: 'Personal y RR. HH.',
      features: [
        { name: 'Directorio de Personal y Turnos', hotelstack: true, competitor: 'Vía Integración' },
        { name: 'Procesamiento de Nómina', hotelstack: true, competitor: false },
        { name: 'Permisos y Asistencia', hotelstack: true, competitor: false },
        { name: 'Analíticas de Desempeño', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$200+',
    hotelstackNote: 'Los 36 módulos incluidos. Incorporación y migración gratuitas. Precios regionales en 6 monedas.',
    competitorNote: 'Precios empresariales ($200+/mes). Implementación e incorporación de pago. Soporte premium con coste adicional.',
  },
  advantages: [
    'Precio inicial aproximadamente un 75% más bajo con más módulos incluidos en cada plan',
    'Incorporación y migración de datos gratuitas vs implementación de pago en Mews',
    'A&B y POS completos integrados vs integración de terceros necesaria con Mews',
    'Precios regionales en 6 monedas — los hoteles pagan en su moneda local',
    'Gestión de personal, nóminas y programación de turnos incluidos',
    'Gestión de mantenimiento y órdenes de trabajo integrada en la plataforma',
    'Soporte dedicado 24/7 vs soporte en horario laboral en Mews',
    'Accesible para hoteles PYME, no solo empresariales — todos los planes incluyen todos los módulos',
  ],
  verdict: {
    title: 'Nuestro Veredicto',
    summary: 'Mews es una excelente plataforma para hoteles empresariales dispuestos a pagar precios premium. HotelStack.io iguala a Mews en UX moderna y arquitectura en la nube mientras añade A&B/POS, gestión de personal y módulos de mantenimiento — todo a aproximadamente un cuarto del precio con incorporación gratuita.',
    bestFor: [
      'Hoteles que desean calidad UX similar a Mews a un precio más accesible',
      'Propiedades que necesitan A&B, POS y herramientas operativas integradas',
      'Hoteles que desean incorporación gratuita sin tarifas de implementación',
      'Hoteles PYME y de escala media excluidos por los planes empresariales de Mews',
      'Cadenas multi-propiedad que necesitan gestión centralizada con cumplimiento regional',
    ],
  },
  faqItems: [
    { question: '¿Cómo se compara HotelStack.io con Mews en calidad de interfaz?', answer: 'Ambas plataformas ofrecen interfaces modernas e intuitivas. HotelStack.io presenta un tema oscuro de lujo diseñado específicamente para la industria hotelera, con 36 módulos totalmente integrados accesibles desde un único panel. Mews tiene un diseño minimalista limpio enfocado en flujos de trabajo europeos.' },
    { question: '¿Incluye Mews capacidades de A&B y POS?', answer: 'Mews requiere integraciones de terceros para A&B y POS. HotelStack.io incluye un terminal POS completo, módulo de servicio a habitación, sistema de pantalla de cocina y gestión de restaurantes como funciones estándar en cada plan.' },
    { question: '¿Puedo obtener la misma experiencia moderna que Mews a un precio menor?', answer: 'Sí. HotelStack.io ofrece una experiencia nativa en la nube moderna con sincronización en tiempo real, interfaz atractiva y 36 módulos a $49/mes vs $200+/mes de Mews. Además, la incorporación y migración son gratuitas.' },
    { question: '¿Ofrece HotelStack.io integraciones API como Mews?', answer: 'Sí. HotelStack.io proporciona un marketplace de integraciones con APIs para pasarelas de pago, OTAs, software de contabilidad y servicios de terceros. Nuestra arquitectura API-first soporta integraciones personalizadas para requisitos empresariales.' },
  ],
};

export const COMPARISON_ES: Record<string, ComparisonConfig> = {
  'hotelstack-vs-hotelogix': HOTELOGIX_ES,
  'hotelstack-vs-cloudbeds': CLOUDBEDS_ES,
  'hotelstack-vs-mews': MEWS_ES,
};
